export default {
  jobList: [],
  jobDetails: null,
  batchDetails: null,
  batchList: [],
};
